var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailArrowUpDarkGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0833 12.2474V8.7474M11.0833 8.7474L9.91667 9.91406M11.0833 8.7474L12.25 9.91406M12.25 6.41406V4.78073C12.25 4.12734 12.25 3.80064 12.1228 3.55107C12.011 3.33155 11.8325 3.15307 11.613 3.04122C11.3635 2.91406 11.0367 2.91406 10.3833 2.91406H3.61667C2.96327 2.91406 2.63657 2.91406 2.38701 3.04122C2.16749 3.15307 1.98901 3.33155 1.87716 3.55107C1.75 3.80064 1.75 4.12734 1.75 4.78073V9.21406C1.75 9.86745 1.75 10.1942 1.87716 10.4437C1.98901 10.6632 2.16749 10.8417 2.38701 10.9536C2.63657 11.0807 2.96327 11.0807 3.61667 11.0807H7.58333M12.0206 4.81706L9.07077 6.7836C8.32236 7.28253 7.94815 7.53202 7.54367 7.62897C7.1862 7.7146 6.81357 7.7146 6.45616 7.62897C6.05168 7.53202 5.67746 7.28253 4.92902 6.7836L1.83602 4.7216",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailArrowUpDarkGray);
export default __webpack_public_path__ + "static/media/mail-arrow-up-dark-gray.22a38ab4ae74beef03aa93a21f214274.svg";
export { ForwardRef as ReactComponent };